<template>
    <div class="home">
        <link rel="stylesheet" href="//fonts.googleapis.com/icon?family=Material+Icons">

        <div class="columns is-centered is-desktop is-tablet" >
            <div class="column is-hidden-mobile">
                <article class="media">
                    <figure class="media-left m-t-20">
                        <img src="./../assets/dai-hua.jpg" alt="Dai Hua">
                    </figure>
                    <div class="media-content">
                        <profile></profile>
                    </div>
                </article>
            </div>

            <div class="column is-hidden-tablet">
                <img src="./../assets/dai-hua.jpg" alt="Dai Hua">
            </div>

            <div class="column is-hidden-tablet">
                <profile></profile>
            </div>

            <div class="column is-one-third">
                <gmap></gmap>
            </div>
        </div>

        <div style="margin: 0 20px 0 20px;">
            <lessons></lessons>

                <section class="hero is-dark">
                    <div class="hero-body" style="padding: 15px;">
                    <div class="container" style="text-align: left;">
                        <h3>Source: <a    href="https://www.irs.gov/businesses/small-businesses-self-employed/arizona-tax-workshops-meetings-and-seminars" target="_blank" style="text-decoration:underline;">IRS Tax Workshops, Meetings and Seminars</a>
                        </h3>

                        <h3>Register for classes at: <a href="https://www.phoenixpubliclibrary.org/hive/programs/irs-financial-tax-series" target="_blank" style="text-decoration:underline;">Phoenix Library Website</a>
                        </h3>
                    </div>
                    </div>
                </section>
        </div>
        <br/>

    </div>

</template>

<script>

import Profile from './home/Profile'
import Gmap from './home/Gmap'
import Lessons from './home/Lessons'

export default {
    name: 'home',
    components: {
        Profile,
        Gmap,
        Lessons,
    },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" >
html {
    // background-image: url("./../assets/wood-bkg.jpg") ;
    background-image: url("./../assets/images/dark-wood-bkg.jpg");
    background-position: top center;
    background-repeat:  no-repeat;
    background-attachment: fixed;
    background-size:  cover;
    background-color: #999;
}
.table h1 {
    font-size: 2em;
}
.table h2 {
    font-size: 1.5em
}

.message-body {
    text-align: left;
}
.panel-block,
.panel-block strong {
    color: #FFFFFF;
    text-align: left;
}
.no-border-bottom {
    border-bottom: none;
}
.message-header h1 {
    color: yellow;
    font-weight: bold;
}
.table tr:hover {
    background-color: initial !important;
}

.table td, .table th {
    border: none !important;
}

ul {
  list-style-type: disc !important;
  padding: 0;
}

li {
  margin: 0 10px;
}

a:hover,
.tabs a{
    color: #fff;
}

.m-t-20 {
    margin-top: 20px;
}

.m-b-20 {
    margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// Home.vue?3b6bfa0c